import React from "react";


export const PickHourSlide = () => {
    return (
        <div className="swiper-container pickslide-day-hour">
            <div className="swiper-wrapper">
                <div className="swiper-slide"><span>01</span></div>
                <div className="swiper-slide"><span>02</span></div>
                <div className="swiper-slide"><span>03</span></div>
                <div className="swiper-slide"><span>04</span></div>
                <div className="swiper-slide"><span>05</span></div>
                <div className="swiper-slide"><span>06</span></div>
                <div className="swiper-slide"><span>07</span></div>
                <div className="swiper-slide"><span>08</span></div>
                <div className="swiper-slide"><span>09</span></div>
                <div className="swiper-slide"><span>10</span></div>
                <div className="swiper-slide"><span>11</span></div>
                <div className="swiper-slide"><span>12</span></div>
            </div>
        </div>
    );
};
